import { render, staticRenderFns } from "./CreateISR.vue?vue&type=template&id=6c8ab024"
import script from "./CreateISR.vue?vue&type=script&lang=js"
export * from "./CreateISR.vue?vue&type=script&lang=js"
import style0 from "./CreateISR.vue?vue&type=style&index=0&id=6c8ab024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports